import React from 'react';
import Floater from 'react-floater';

const FloaterDialog = ({delay=3, ...props}) =>
{
    const style = { ...props.style , ... { color: props.color, marginLeft: '6px', marginRight: '6px' }};

    const floaterStyles = {
        container: {
            borderRadius: '10px',
            backgroundColor: '#dce8f1'
        },
        arrow: {
            color: '#dce8f1'
        }
    } ;

    return (
        <Floater styles={floaterStyles} style={{ float: 'right'}} eventDelay={delay} event='hover' content={props.text}>
            <span style={style}>
                <i className={props.icon} style={props.iconStyle}></i>
            </span>
        </Floater>
    )
}

export default FloaterDialog ;